/**
 * @generated SignedSource<<689331e131f4f21a71f18b0535b77274>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrganizationTab_brand$data = {
  readonly email: string;
  readonly " $fragmentSpreads": FragmentRefs<"useBrandUpdateMutation_brand">;
  readonly " $fragmentType": "OrganizationTab_brand";
};
export type OrganizationTab_brand$key = {
  readonly " $data"?: OrganizationTab_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationTab_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrganizationTab_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBrandUpdateMutation_brand"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "1004c393144a0dfc19b75932541a612a";

export default node;
